export default {
    // 公共模块
    common: {
        simplifiedChinese: '简体中文',
        ChineseTraditional: '繁體中文',
        English: 'English',
        personalCenter: 'Personal Center',
        contactCustomerService: 'Contact customer service',
        logOut: 'Log out',
        home: 'Home page',
        deviceManagement: 'Device management',
        roleAssignment: 'Role assignment',
        powerDistribution: 'Permission distribution',
        accountManagement: 'Account management',
        pleaseEnterName: 'Please enter',
        pleaseSelectName: 'Please select',
        date: 'Content',
        sex: 'Sex',
        workingSchedule: 'working schedule',
        serial: 'Serial number',
        operation: 'Operation',
        empty: 'Empty',
        query: 'Query',
        del: 'Delete',
        operateSuccess: 'Operation succeeded',
        passwd: 'Password',
        remark: 'Remarks',
        isDisabled: 'Whether to disable',
        disabled: 'Disabled',
        notDisabled: 'Not disabled',
        pleaseEnter: 'Please enter',
        pleaseSelect: 'Please select',
        roleName: 'Role name',
        jurisdictionIds: 'Permission id',
        addingRoles: 'Add roles',
        editRole: 'Edit role',
        addRights: 'Add permission',
        changePermission: 'Modify permission',
        PermissionName: 'Permission name',
        authorityCredentials: 'Permission value',
        nameAccount: 'Account name',
        roleId: 'Permission id',
        addAccount: 'Add an account',
        modifyAccount: 'Modify the account',
        ClientManagement: 'Client management',
        addUser: 'add user',
        passwordPrompt: 'password prompt',
        telephone: 'telephone',
        languageSwitch: 'language switch',
        verificationCode: 'verification code',
        logIn: 'log in',
        getCode: 'get code',
        afterObtaining: 's after obtaining',
        pleaseWait: 'please wait...',
        loginFailure: 'login failure',
        WelcomeTo: 'Welcome to',
        DeviceUuid: 'device uuid',
        deviceInterface: 'add equipments',
        changeDeviceInterface: 'Modify equipment',
        bindingInterface: 'Binding Interface Wi-Fi',
        wifi: 'Wi-Fi',
        add: 'Add',
        name: "Name",
        email: "Email",
        createTime: "Creation time",
        lastTime: "Modification Time",
        edit: "Edit",
        Cancel: "Cancel",
        Confirm: "Confirm",
        pleaseEnterSamePassword: "Please enter the same password",
        weekday: "weekday",
        startTime: "Start time",
        endTime: "End Time",
        deviceList: 'Device List',
        workforceManagement: "Scheduling Management",
        credentialManagement: "Document Management",
        workerManagement: "Worker Management",
        facePhoto: "Facial photo",
        photo: "Photo",
        scheduling: "Scheduling",
        Monday: "Monday",
        Tuesday: "Tuesday",
        Wednesday: "Wednesday",
        Thursday: "Thursday",
        Friday: "Friday",
        Saturday: "Saturday",
        Weekday: "Sunday",
        IdentificationCard: "Identification Card (Blue Card)",
        MacauResidentIdentityCard: "Macau Resident Identity Card",
        certificateType: "Document Type",
        certificateTimeStart: "Certificate validity period begins",
        certificateTimeEnd: "The validity period of the certificate has ended",
        MasterCardNot: "Whether it is a master card",
        yes: "Yes",
        no: "No",
        IDNumber: "ID number",
        OnlyOneImage: "Only one image can be uploaded",
        pictureSize: "The size of the uploaded image cannot exceed \"{size}MB !\"",
        pictureFormat: "Uploading images can only be in {type} format!",
        ChangePassword: "Change password",
        AttendanceManagement: "Attendance management",
        DeviceNoteInformation: "Device note information",
        DeviceSNCode: "Device SN code",
        OnlineOrNot: "Online or not",
        DeleteWhitelist: "Delete whitelist",
        RemoteDoorOpening: "Remote door opening",
        RemoteRestartOfDevices: "Remote restart of devices",
        DeleteDeviceRecords: "Delete device records",
        CompanyName: "GUANGDONG-GONG KONG-MACAU GREATER BAY AREA TECHNOLOGY",
        SyncToDevice: "sync to device",
        DataStatistics: "data statistics",
        PersonnelManagementSystem: "Personnel management system",
        NotConfigured: "Not configured yet",
        EmployeeInformationEditing: "Employee Information Editing",
        EmployeeCredentialsEditor: "Employee credentials editor",
        AddEmployeeCredentials: "Add employee credentials",
        CertificateRemarks: "Certificate remarks",
        user: "user",
        employee: "employee",
        type: "type",
        triggeringTime: "triggering time",
        ExportForm1: "Export the punch record",
        ExportForm2: "Export all clocking times",
        equipment: "equipment",
        AssociatedWithTheScheduledWorkers: "Employees associated with scheduling",
        dateRange: "date range",
        snCode: "SN code",
        DeviceSn: "Device SN code (please check directly on the device)",
        StartDate: "Start Date",
        EndDate: "End Date",
        ClockIn: "Clock In",
        ClockOut: "Clock Out",
        leave: "leave",
        takeVacation: "take vacation",
        annualLeave: "annual leave",
        evection: "evection",
        rests: "rests",
        man: "man",
        woman: "woman",
        CrossDayOrNot: "Cross-day or not",
        IDPhoto: "ID Photo",
        dateOnBoard: "Date of Employment",
        dateOfDeparture: "Resignation date",
        emergencyContact: "Emergency Contact",
        EmergencyContactNumber: "Emergency contact phone number",
        EmployeeID: "Employee ID",
        hourlyWage: "hourly wage",
        dailyWage: "daily wage",
        monthlyPay: "monthly pay",
        SalaryCalculationMethod: "Salary calculation method",
        remuneration: "Salary",
        pleaseUpload: "Please upload {name}",
        requiredField: "Required Field",
        to: "To",
        AdditionalShift: "Add shift",
        classes: "Shift",
        TimeRequiredForAttendance: "Expected attendance duration",
        intermission: "Rest time in between",
        SchedulingType: "Scheduling Type",
        FixedSchedule: "Fixed scheduling",
        IntelligentSchedule: "Intelligent scheduling",
        jobcard: "Job Safety Card",
        macao: "Macau Resident Identity Card",
        laborid: "Foreign Labor Certificate",
        hkid: "Hong Kong Resident Identity Card",
        chinaid: "Mainland Resident Identity Card",
        chinapermit: "Mainland residents' roads",
        more: "More",
        AddMaximum: "A maximum of {numb} shifts can be added",
        noData: 'no data',
        attentionPleaseTips: 'Please pay attention!! The following documents are about to expire, please handle them in advance',
        systematicNotification: 'System notifications',
        officeHours: 'work hours',
        closingTime: 'closing Time',
        ClockingTime: 'Clocking Time',
        ProcessingFailure: "Processing failed. If you have any questions, please contact the administrator.",
        OffLine: "Offline",
        OnLine: "Online",
        tips1: "Please note that your employee ID: {num} may be duplicated. If you confirm that there are no duplicates, please contact the administrator.",
        tips2: "Please note that your ID number: {num} may be duplicated. If you confirm that there are no duplicates, please contact the administrator.",
        hourFormat: "(in hours) can be decimal",
        ExportForm3: "Export scheduling table",
        MenuPermission: "Menu Permissions",
        beLate: "Late",
        leaveEarly: "Leave early",
        overtime: "Overtime",
        tips3: "This operation will delete the document. Do you want to delete it?",
        hint: "Hint",
        managerName: "Account Name",
        tips4: "Please note that the account name has already been used, please modify the account name.",
        superManager: "Super Administrator",
        ordinaryManager: "Ordinary administrator",
        tips5: "Add device failed: device SN already exists",
        PunchType: "Punch Type",
        plan: "plan",
        ActualAttendanceTime: "Actual Attendance Time",
        yyyymmdd: "date",
        ProductMicrocosmic: "Product Microscopy",
        SchedulingManagementSystem: "Scheduling Management System",
        IntelligentUnlocking: "Intelligent unlocking",
        onlineShoppingMall: "Online Shopping Mall",
        partner: "Partner",
        AboutUs: "About Us",
        allRightReserved: "All rights reserved",
        contactUs: "Contact us",
        content1: "Easily achieve enterprise level personnel management",
        content2: "Quickly perform tedious functions such as personnel scheduling and table export",
        content3: "Intelligent buildings; intelligent property management; monitoring systems; anti-theft systems; e-commerce; website establishment, etc.",
        content4: "Build a mobile e-commerce platform, provide one click deployment, and achieve a simple, reliable, and stable business platform.",
        content5: "We come from different regions and come together because of our dreams. We form teams, and each team member has the same facial features as others, and none of them can be missing.",
        content6: "With strength as the shield and confidence as the spear. We firmly believe that success depends on friends, growth depends on opponents, and achievement depends on teamwork.",
        title3: "Enterprises engaged in",
        title4: "Core Concepts",
        title5: "Team Style",
        title6: "Corporate Spirit",
        btn1: "Experience usage",
        BayAreaTechnology: "Bay Area Technology.",
        Macao: "Macau",
        MacaoContent1: "Gathering My Wisdom",
        MacaoContent2: "Control the excitement",
        MacaoContent3: "Surprise you",
        MacaoContent4: "Pioneering the new century, leading the way in creating brilliance.",
        MacaoContent5: "Joining the Dream of the Greater Bay Area and Creating a Better Future.",
        gongSi1: "Company name",
        gongSi2: "Zezhaosheng Software Development Center",
        gongSi3: "Business Scope",
        gongSi4: "General Projects: Development of Artificial Intelligence Theory and Algorithm Software; Development of Artificial Intelligence Basic Software; Software Development; Software Sales; Internet Sales (except for the sale of licensed goods); Retail of Computer Software and Hardware and Auxiliary Equipment; Sales Agency. (Except for projects that require approval by law, business activities can be conducted independently based on the business license in accordance with the law)",
        gongSi5: "Four Seasons Yingji Cultural Activity Planning Studio",
        gongSi6: "General Projects: Organizing cultural and artistic exchange activities; Photography and video production services; Photography and printing services. (Except for projects that require approval according to law, business activities can be carried out independently with a business license in accordance with the law)",
        gongSi7: "Yufeng Communication Hydropower Engineering Company",
        gongSi8: "Construction engineering construction; Construction engineering design; Road freight transportation (excluding dangerous goods); Sales of communication equipment; Sales of building materials; Software development; Loading and unloading handling; Labor services (excluding labor dispatch).",
        IntelligentUnlocking: "Intelligent unlocking system",
        ScienceAndInnovationLife: "Science and innovation life",
        CommittedTo: "Committed to the future of technology in the Bay Area",
        theNumberOfUsers: "the number of users",
        serviceTeam: "service team",
        ao: "MO",
    },
}
